<template>
  <div :class="className" ref="contextmenu" class="atb-contextmenu-container common-datagrid" @click="removeHtml" @contextmenu.prevent="contextmenuHandle" :hidden="hidden">
    <div class="atb-contextmenu" :style="{left: contextmenuEvent.x + 'px',top: contextmenuEvent.y + 'px', maxHeight: contextmenuEvent.maxHeight + 'px'}">
      <template v-for="(d,index) in data">
        <div class="atb-contextmenu-item" v-if="d.title && !d.type && d.field != 'option'" :key="index" @click.stop="funcEmit(d)">
          <span class="icon-container">
            <i class="el-icon-check" v-if="d.visible"></i>
          </span>
          {{d.title}}
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    selector: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: ()=>[]
    }
  },
  data() {
    return {
      hidden: true,
      contextmenuEvent: {}
    }
  },
  mounted () {
    this.$nextTick(() => {
      const body = document.querySelector("body");
      if (body.append) {
        body.append(this.$el);
      } else {
        body.appendChild(this.$el);
      }
      let doc = document.querySelector(this.selector)
      if(doc){
        this.addContextMenuListen(doc)
      }
    })
  },
  methods: {
    funcEmit(d){
      this.$emit('columnHideToggle',d)
    },
    addContextMenuListen(doc){
      doc.oncontextmenu = (e)=>{
        this.contextmenuHandle(e)
        return false
      }
    },
    contextmenuHandle(e){
      this.contextmenuEvent = {
        x: e.x,
        y: e.y
      }
      this.hidden = false
      this.resetHtmlSize()
    },
    resetHtmlSize(){
      setTimeout(()=>{
        var bodyWidth = this.$refs.contextmenu.clientWidth
        var bodyHeight = this.$refs.contextmenu.clientHeight
        var contextMenu = this.$refs.contextmenu.querySelector('.atb-contextmenu')
        this.$set(this.contextmenuEvent,'maxHeight',bodyHeight - 20)
        if(contextMenu.clientHeight + this.contextmenuEvent.y > bodyHeight){
          if(contextMenu.clientHeight > this.contextmenuEvent.y){
            this.contextmenuEvent.y = 10
          }else{
            this.contextmenuEvent.y = this.contextmenuEvent.y - contextMenu.clientHeight
          }
        }
        if(contextMenu.clientWidth + this.contextmenuEvent.x > bodyWidth){
          if(contextMenu.clientWidth > this.contextmenuEvent.x){
            this.contextmenuEvent.x = 10
          }else{
            this.contextmenuEvent.x = this.contextmenuEvent.x - contextMenu.clientWidth
          }
        }
      },0)
    },
    removeHtml(){
      this.hidden = true
    }
  }
}
</script>
<style lang="scss" scoped>
.atb-contextmenu-container{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10001;
}
.atb-contextmenu{
  position: fixed;
  font-size: 14px;
  background-color: white;
  box-shadow: 0px 0px 5px #aaaaaa;
  overflow: auto;
  border-radius: 3px;
}
.atb-contextmenu-item{
  padding: 5px 15px 5px 15px;
  cursor: pointer;
  /*font-size: 16px;*/
  line-height: 25px;
}
.atb-contextmenu-item:last-child{
  border-bottom-color: transparent
}
.atb-contextmenu-item.group-item{
  margin-bottom: 5px;
  border-bottom: 1px solid #cccccc;
}
.atb-contextmenu-item:hover{
  background-color: #c9f1eb;
  border-left: solid 2px #148a81;
}
.atb-contextmenu::-webkit-scrollbar {/*滚动条整体样式*/
  width: 3px;     /*高宽分别对应横竖滚动条的尺寸*/
  height: 3px;

}
.atb-contextmenu::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
  border-radius: 5px;
  background: rgba(0,0,0,0.2);
}
.atb-contextmenu::-webkit-scrollbar-track {/*滚动条里面轨道*/
  border-radius: 0;
  background: rgba(0,0,0,0.1);
}
.atb-contextmenu::-webkit-scrollbar {/*滚动条整体样式*/
  width: 3px;     /*高宽分别对应横竖滚动条的尺寸*/
  height: 3px;
}
.atb-contextmenu::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
  border-radius: 5px;
  background: rgba(0,0,0,0.2);
}
.atb-contextmenu::-webkit-scrollbar-track {/*滚动条里面轨道*/
  border-radius: 0;
  background: rgba(0,0,0,0.1);
}
.icon-container{
  color: #148a81;
  display: inline-block;
  width: 40px;
  font-weight: bold;
  text-align: center;
}
</style>
